import axios from 'axios';

// Reddit API base URL
const REDDIT_API_BASE = 'https://www.reddit.com';

// Subreddits to search in
const FERTILITY_SUBREDDITS = [
  'infertility',
  'IVF',
  'tryingforababy',
  'fertility'
];

export const searchRedditPosts = async (query) => {
  try {
    // Create an array of promises for each subreddit search
    const searchPromises = FERTILITY_SUBREDDITS.map(async (subreddit) => {
      const url = `${REDDIT_API_BASE}/r/${subreddit}/search.json`;
      console.log(`Searching in r/${subreddit}:`, query);
      
      const response = await axios.get(url, {
        params: {
          q: query,
          restrict_sr: true, // Restrict to subreddit
          sort: 'relevance',
          limit: 5,
          t: 'all',
          raw_json: 1
        }
      });

      return response.data.data.children || [];
    });

    // Wait for all searches to complete
    const results = await Promise.all(searchPromises);
    
    // Flatten and transform the results
    const allPosts = results
      .flat()
      .map(post => ({
        id: post.data.id,
        title: post.data.title,
        content: post.data.selftext || post.data.title, // Fallback to title if no selftext
        author: post.data.author,
        upvotes: post.data.ups,
        comments: post.data.num_comments,
        url: `https://reddit.com${post.data.permalink}`,
        subreddit: post.data.subreddit_name_prefixed,
        created: post.data.created_utc
      }))
      .filter(post => post.content && post.content.length > 0) // Filter out posts with no content
      .sort((a, b) => b.upvotes - a.upvotes); // Sort by upvotes

    console.log('Found posts:', {
      total: allPosts.length,
      bySubreddit: FERTILITY_SUBREDDITS.map(subreddit => ({
        subreddit,
        count: allPosts.filter(post => post.subreddit === `r/${subreddit}`).length
      }))
    });

    // Return top 10 most relevant posts
    return allPosts.slice(0, 10);
  } catch (error) {
    console.error('Error fetching Reddit posts:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
}; 